/* A statement of fact, not an action — it must not read as something you can press. */
.added {
  color: var(--tuna-content-secondary);
}

/*
 * A flex item stretches in the cross axis by default, so an `inline-flex` Button in a column
 * layout still goes full-bleed. `align-self` is what actually holds it to its label; the
 * `inline-flex` here keeps the wrapper from becoming the full-width box instead.
 */
.trigger {
  display: inline-flex;
  align-self: flex-start;
}
